import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Github, Linkedin, Mail, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Home from './pages/Home';
import ToolDetail from './pages/ToolDetail';
import './App.css';

function App() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Router>
      <div className="App">
        <div className="language-selector">
          <Globe size={18} />
          <button 
            className={i18n.language.startsWith('en') ? 'active' : ''} 
            onClick={() => changeLanguage('en')}
          >
            EN
          </button>
          <span>|</span>
          <button 
            className={i18n.language.startsWith('fr') ? 'active' : ''} 
            onClick={() => changeLanguage('fr')}
          >
            FR
          </button>
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tool/:id" element={<ToolDetail />} />
        </Routes>

        <footer>
          <div className="footer-content">
            <div className="footer-section">
              <h4>{t('footer_about_title', 'About')}</h4>
              <p>{t('footer_about_text', 'AI Directory is your companion for navigating the ever-evolving AI ecosystem.')}</p>
            </div>
            <div className="footer-section">
              <h4>{t('footer_contact_title', 'Contact')}</h4>
              <div className="social-links">
                <a href="https://github.com/saiiimiiir" target="_blank" rel="noreferrer"><Github size={20} /></a>
                <a href="https://www.linkedin.com/in/saimir-djoumoi-86a458b1/" target="_blank" rel="noreferrer"><Linkedin size={20} /></a>
                <a href="mailto:contact@saimirdjoumoi.fr"><Mail size={20} /></a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Monsieur. {t('footer_rights', 'All rights reserved.')}</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
